/**
 * @generated SignedSource<<2573a60449c088b84e1bf3214d2e8f38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FeedbackEventType = "DECLINED" | "PROVIDED" | "%future added value";
export type FeedbackInitiatedBy = "SERVER" | "USER" | "%future added value";
export type addFeedbackEventInput = {
  clientMutationId?: string | null;
  feedbackEvent: FeedbackEventInput;
};
export type FeedbackEventInput = {
  comment?: string | null;
  initiatedBy?: FeedbackInitiatedBy | null;
  isSatisfied?: boolean | null;
  type: FeedbackEventType;
};
export type AddFeedbackEventMutation$variables = {
  input: addFeedbackEventInput;
};
export type AddFeedbackEventMutation$data = {
  readonly addFeedbackEvent: {
    readonly errors: ReadonlyArray<{
      readonly __typename: "AuthError";
      readonly message: string;
    }>;
    readonly user: {
      readonly doPromptFeedback: boolean;
      readonly id: string;
    } | null;
  } | null;
};
export type AddFeedbackEventMutation = {
  response: AddFeedbackEventMutation$data;
  variables: AddFeedbackEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "addFeedbackEventPayload",
    "kind": "LinkedField",
    "name": "addFeedbackEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "doPromptFeedback",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddFeedbackEventMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddFeedbackEventMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "28076ac8fb6b002a7f5b688ecce0de69",
    "id": null,
    "metadata": {},
    "name": "AddFeedbackEventMutation",
    "operationKind": "mutation",
    "text": "mutation AddFeedbackEventMutation(\n  $input: addFeedbackEventInput!\n) {\n  addFeedbackEvent(input: $input) {\n    user {\n      id\n      doPromptFeedback\n    }\n    errors {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6b2fb86e615ce602ebd819f71ff99a71";

export default node;
